<app-detail-template>
  <div container-header>
    <retrieval-ft-detail-header></retrieval-ft-detail-header>
  </div>
  <div container-body>
    <router-outlet></router-outlet>
  </div>
</app-detail-template>
